var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.25 12.25Q14 10.5 14 8t-1.75-4.25T8 2 3.75 3.75 2 8t1.75 4.25T8 14t4.25-1.75M8 16q-3.35 0-5.675-2.325T0 8t2.325-5.675T8 0t5.675 2.325T16 8a7.85 7.85 0 0 1-1.675 4.9L20 18.6 18.6 20l-5.7-5.675A7.854 7.854 0 0 1 8 16"
})));
export default SvgSearch;